export default (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke-width="1.5" />
    <path
      d="M8 10.5L11.7 13.275C11.8778 13.4083 12.1222 13.4083 12.3 13.275L16 10.5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
